import Box from '@mui/material/Box'
import FormLabel from '@mui/material/FormLabel'
import Typography from '@mui/material/Typography'
import { numberWithCommas } from '@shared/utils'

import {
  MultiSelectAccordionDetails,
  MultiSelectWrap,
  SelectCheckbox,
  SelectFormControlLabel,
  SelectLabelText,
  SelectLabelWrapper,
} from '../../index.styles'

interface Props<Value> {
  values: Value[]
  label: string
  options: { label: string; value: Value; total?: string; forceChecked?: boolean }[]
  onChange: (value: Value) => void
}

const MultiSelect = <TValue extends number | string>(props: Props<TValue>) => {
  const { values: selectedValues, label, options, onChange } = props

  return (
    <Box data-testid="multi_select">
      <FormLabel>{label}</FormLabel>
      <MultiSelectAccordionDetails>
        <MultiSelectWrap>
          {options.map(i => (
            <SelectFormControlLabel
              key={i.value}
              tabindex="0"
              onKeyPress={(event: React.KeyboardEvent) => {
                if (event.key === 'Enter') {
                  onChange(i.value)
                }
              }}
              control={
                <SelectCheckbox
                  disableRipple
                  checked={(selectedValues as (string | number)[]).includes(i.value) || false} // || i.forceChecked}
                  onChange={() => onChange(i.value)}
                  inputProps={{ 'aria-label': 'controlled' }}
                  onKeyPress={(event: React.KeyboardEvent) => {
                    if (event.key === 'Enter') {
                      onChange(i.value)
                    }
                  }}
                />
              }
              label={
                <SelectLabelWrapper>
                  <SelectLabelText variant="body2" data-testid="multi_select_label">
                    {i.label}
                  </SelectLabelText>
                  {!!i.total && (
                    <Typography variant="body2" data-testid="multi_select_total">
                      ({numberWithCommas(i.total)})
                    </Typography>
                  )}
                </SelectLabelWrapper>
              }
            />
          ))}
        </MultiSelectWrap>
      </MultiSelectAccordionDetails>
    </Box>
  )
}

export default MultiSelect
